// Mock data for Safranbolu Çelebi Otel premium clone
// NOTE: All data here is MOCKED for the frontend-only teaser.

// Images are hosted locally on the server (optimized), not hotlinked.
const IMG = "/images";

export const hotel = {
  name: "Safranbolu Çelebi Otel",
  shortName: "Çelebi Otel",
  logoWhite: "/brand/logo-white.png",
  logoDark: "/brand/logo-dark.png",
  whatsapp: "905457787800",
  whatsappIntro: "Merhaba, Safranbolu Çelebi Otel'de konaklama için bilgi almak istiyorum.",
  tagline: "Safranbolu'daki birinci sınıf konaklama tercihiniz",
  slogan: "Be Our Guest",
  descriptionShort:
    "UNESCO Dünya Mirası Safranbolu'nun kalbinde, tarihin ve modern konforun buluştuğu ayrıcalıklı bir konaklama deneyimi.",
  phones: ["0 370 712 28 80", "0 545 778 78 00", "0 370 712 51 51"],
  fax: "0 370 712 31 00",
  email: "info@safranbolucelebiotel.com",
  address:
    "Atatürk Mahallesi, Sadri Artunç Caddesi No: 80, Safranbolu / Karabük",
  mapEmbed:
    "https://www.google.com/maps?q=Safranbolu%20Atat%C3%BCrk%20Mahallesi%20Sadri%20Artun%C3%A7%20Caddesi&output=embed",
};

export const heroSlides = [
  {
    image: `${IMG}/Safranbolu_Celebi_Otel-50-1024x684.jpg`,
    title: "Safranbolu'nun Kalbinde Zarafet",
    subtitle: "Tarihi dokuyla modern konforun eşsiz buluşması",
  },
  {
    image: `${IMG}/Safranbolu_Celebi_Otel-51-1024x684.jpg`,
    title: "Zarafetin ve Konforun Adresi",
    subtitle: "Her detayın özenle düşünüldüğü ayrıcalıklı odalar",
  },
  {
    image: `${IMG}/Safranbolu_Celebi_Otel-53-1024x684.jpg`,
    title: "UNESCO Mirasının Konuğu Olun",
    subtitle: "Dünya mirası şehrin merkezinde eşsiz bir tatil",
  },
  {
    image: `${IMG}/Safranbolu_Celebi_Otel-68-1024x684.jpg`,
    title: "Be Our Guest",
    subtitle: "Misafirperverliğin en zarif hali sizi bekliyor",
  },
];

export const amenities = [
  { icon: "BedDouble", title: "Doğal Tekstil Yataklar", desc: "Doğal tekstil ürünlerinden konforlu yatak ve yastıklar" },
  { icon: "Snowflake", title: "Split Klima", desc: "Her odada bireysel iklimlendirme kontrolü" },
  { icon: "Coffee", title: "Çay / Kahve Seti", desc: "Ücretsiz çay & kahve seti ve su ısıtıcısı" },
  { icon: "Phone", title: "Odada Telefon", desc: "Kesintisiz iletişim için oda telefonu" },
  { icon: "ShowerHead", title: "Duşakabinli Banyo", desc: "Modern duşakabinli özel banyo" },
  { icon: "Sparkles", title: "Lüks Banyo Ürünleri", desc: "Geniş havlu, terlik ve lüks banyo malzemeleri" },
  { icon: "Wind", title: "Saç Kurutma Makinesi", desc: "Konforunuz için her odada mevcut" },
  { icon: "Tv", title: "LED TV", desc: "Yüksek kalitede izleme deneyimi" },
  { icon: "Wine", title: "Minibar", desc: "Odanızda taze içecek ve atıştırmalıklar" },
  { icon: "Wifi", title: "Ücretsiz Wi-Fi", desc: "Ücretsiz kablosuz internet bağlantısı" },
  { icon: "Clock", title: "24 Saat Oda Servisi", desc: "Gece gündüz kesintisiz hizmet" },
  { icon: "Car", title: "Vale Parking", desc: "Vale parking ve uyandırma servisi" },
];

export const rooms = [
  {
    id: "suit-aile",
    name: "Suit Aile Odası",
    price: "₺ 4.800",
    priceNote: "gecelik başlangıç",
    size: "45 m²",
    capacity: "2 + 2 Kişi",
    bed: "1 King + 2 Tek Yatak",
    short:
      "Aileler için tasarlanmış, ferah oturma alanı ve zarif detaylarla donatılmış en prestijli suit odalarımız.",
    features: ["Ferah oturma alanı", "King & tek yataklar", "Split klima", "Minibar", "LED TV", "Lüks banyo"],
    cover: `${IMG}/Safranbolu_Celebi_Otel-34-1024x684.jpg`,
    gallery: [
      `${IMG}/Safranbolu_Celebi_Otel-34-1024x684.jpg`,
      `${IMG}/Safranbolu_Celebi_Otel-33-1024x684.jpg`,
      `${IMG}/Safranbolu_Celebi_Otel-31-1024x684.jpg`,
      `${IMG}/Safranbolu_Celebi_Otel-30-1024x684.jpg`,
      `${IMG}/Safranbolu_Celebi_Otel-27-1024x684.jpg`,
      `${IMG}/Safranbolu_Celebi_Otel-26-1024x684.jpg`,
      `${IMG}/Safranbolu_Celebi_Otel-25-1024x684.jpg`,
      `${IMG}/Safranbolu_Celebi_Otel-29-1024x684.jpg`,
    ],
  },
  {
    id: "standart-aile",
    name: "Standart Aile Odası",
    price: "₺ 3.400",
    priceNote: "gecelik başlangıç",
    size: "32 m²",
    capacity: "2 + 1 Kişi",
    bed: "1 Fransız + 1 Tek Yatak",
    short:
      "Sıcak dokular ve modern konforu bir araya getiren, aileler için ideal ferah odalarımız.",
    features: ["Konforlu aile düzeni", "Doğal tekstil", "Split klima", "Minibar", "LED TV", "Ücretsiz Wi-Fi"],
    cover: `${IMG}/STANDART-AILE8-1024x683.jpg`,
    gallery: [
      `${IMG}/STANDART-AILE8-1024x683.jpg`,
      `${IMG}/STANDART-AILE6-jpg-1024x683.jpg`,
      `${IMG}/STANDART-AILE7-jpg-1024x683.jpg`,
      `${IMG}/STANDART-AILE5-1024x683.jpg`,
      `${IMG}/STANDART-AILE4-1024x684.jpg`,
      `${IMG}/STANDART-AILE3-1024x684.jpg`,
      `${IMG}/STANDART-AILE2-1024x684.jpg`,
      `${IMG}/STANDART-AILE1-1024x684.jpg`,
    ],
  },
  {
    id: "double",
    name: "Double Oda",
    price: "₺ 2.900",
    priceNote: "gecelik başlangıç",
    size: "26 m²",
    capacity: "2 Kişi",
    bed: "1 Fransız Yatak",
    short:
      "Çiftler ve iş seyahatleri için sakin, zarif ve tam donanımlı konfor odalarımız.",
    features: ["Fransız yatak", "Duşakabinli banyo", "Split klima", "Minibar", "LED TV", "Oda telefonu"],
    cover: `${IMG}/Safranbolu_Celebi_Otel-43-1024x684.jpg`,
    gallery: [
      `${IMG}/Safranbolu_Celebi_Otel-43-1024x684.jpg`,
      `${IMG}/Safranbolu_Celebi_Otel-45-1024x684.jpg`,
      `${IMG}/Safranbolu_Celebi_Otel-46-1024x684.jpg`,
      `${IMG}/Safranbolu_Celebi_Otel-50-1024x684.jpg`,
      `${IMG}/2023-aralik-celebiotel-044-scaled-1-1024x684.jpg`,
      `${IMG}/2023-aralik-celebiotel-047-scaled-1-1024x684.jpg`,
      `${IMG}/2023-aralik-celebiotel-048-scaled-1-1024x684.jpg`,
      `${IMG}/2023-aralik-celebiotel-049-scaled-1-1024x684.jpg`,
    ],
  },
];

export const restaurant = {
  title: "Çelebi Restaurant",
  intro:
    "Restaurantımız, lezzet tutkunlarının vazgeçilmez adresi. Taze ve kaliteli malzemelerle hazırlanan yemeklerimiz damak zevkinize hitap edecek. Şık ve modern dekorasyonumuzla sizleri ağırlamaktan mutluluk duyacağız.",
  cover: `${IMG}/restaurant/celebi-restaurant.webp`,
  introImage:
    `${IMG}/restaurant/meze-spread.webp`,
  highlights: [
    { icon: "UtensilsCrossed", title: "Yöresel Lezzetler", desc: "Safranbolu'nun geleneksel mutfağından özenle seçilmiş tatlar" },
    { icon: "Croissant", title: "Zengin Açık Büfe Kahvaltı", desc: "Yöresel ürünler ve ev yapımı reçellerle güne başlangıç" },
    { icon: "Grape", title: "Taze Malzeme", desc: "Mevsiminde toplanan taze ve kaliteli malzemeler" },
    { icon: "Wine", title: "Şık Atmosfer", desc: "Modern ve zarif dekorasyonlu keyifli ortam" },
  ],
  // Safranbolu'ya özgü imza lezzetler (özgün yemek görselleri)
  signatureDishes: [
    {
      name: "Bakırda Kuyu Kebabı",
      desc: "Odun ateşinde bakır kap içinde saatlerce yavaş pişen, Safranbolu sofralarının baştacı.",
      img: `${IMG}/restaurant/kuyu-kebabi.webp`,
      alt: "Bakır tepside közlenmiş sebzeler eşliğinde geleneksel Türk kebabı",
    },
    {
      name: "Safranbolu Peruhisi",
      desc: "El açması hamurun kıymalı harçla buluştuğu, sarımsaklı yoğurt ve tereyağıyla sunulan yöresel mantı.",
      img: `${IMG}/restaurant/peruhi.webp`,
      alt: "Bakır kâsede sarımsaklı yoğurtla sunulan el yapımı Türk mantısı",
    },
    {
      name: "Safranlı Zerde",
      desc: "Şehre adını veren safranla renklenen, gül suyu ve fıstıkla süslenen altın rengi geleneksel tatlı.",
      img: `${IMG}/restaurant/zerde.webp`,
      alt: "Desenli tabakta fıstık ve kuru meyvelerle süslenmiş safranlı zerde tatlısı",
    },
    {
      name: "Safranbolu Lokumu",
      desc: "Mineralce zengin sularla yoğrulan, hafif dokusuyla ünlü el yapımı Safranbolu lokumu.",
      img: `${IMG}/restaurant/lokum.webp`,
      alt: "Çeşit çeşit el yapımı Türk lokumu tabağı",
    },
  ],
  menu: [
    { name: "Serpme Köy Kahvaltısı", desc: "Yöresel peynirler, bal-kaymak, ev yapımı reçeller ve sıcak bazlamalarla bereketli bir sofra." },
    { name: "Safranbolu Peruhisi", desc: "El açması hamur, kıymalı iç harç ve sarımsaklı yoğurtla yörenin imza mantısı." },
    { name: "Safranbolu Etli Yaprak Sarma", desc: "Zeytinyağlı ve etli, ince el işçiliğiyle sarılan geleneksel yaprak sarma." },
    { name: "Bakırda Kuyu Kebabı", desc: "Odun ateşinde bakır kapta yavaş pişirilen, ağızda dağılan özel kebap." },
    { name: "Safranlı Zerde", desc: "Gerçek Safranbolu safranıyla hazırlanan, gül suyu ve fıstıkla süslenen geleneksel tatlı." },
    { name: "Safranbolu Lokumu & Türk Kahvesi", desc: "Ev yapımı çeşit çeşit lokum ikramı eşliğinde köpüklü Türk kahvesi." },
  ],
};

const SB = "/images/safranbolu";

export const safranbolu = {
  hero: `${IMG}/safranbolu-2000x1200-1.jpg`,
  heroAlt: "Safranbolu'nun tarihi Osmanlı konaklarıyla dolu gece panoraması",
  intro:
    "Türkiye'nin UNESCO Dünya Miras Listesi'ne ilk giren değerlerinden biri olan Safranbolu, 1994 yılından beri bu listede yer almaktadır. Dünyanın en pahalı baharatlarından olan ve yerleşime de ismini veren safranın en kalitelisi Safranbolu'da yetişmektedir.",

  // Story section (deepens after the serif intro)
  story: {
    eyebrow: "Bir Dünya Mirası",
    title: "Zamanın koruduğu bir açık hava müzesi",
    image: `${SB}/sb-pano-1.webp`,
    imageAlt:
      "Safranbolu'nun kiremit çatılı geleneksel evleri, camileri ve dağ manzarası",
    paragraphs: [
      "İlçe merkezinde 18., 19. ve 20. yüzyıl başlarında yapılmış yaklaşık 2000 geleneksel Türk evi bulunur; bunların 800 kadarı yasal koruma altındadır. Bu eşsiz doku, Türk kent kültürünün günümüzde yaşatılmasına katkıda bulunur.",
      "Safranbolu; birbirine eklenerek büyüyen, doğaya uyum sağlayıp onu koruyan yapısıyla, Osmanlı sivil mimarisinin dünyadaki en iyi korunmuş örneklerinden birini sunar.",
    ],
    stats: [
      { n: "~2.000", l: "Geleneksel konak" },
      { n: "800+", l: "Tescilli yapı" },
      { n: "1994", l: "UNESCO tescili" },
    ],
  },

  // Verified historical timeline (sources: UNESCO, Kültür Bakanlığı, TR/EN Wikipedia)
  timeline: [
    { year: "MÖ ~3000", title: "İlk Yerleşim", text: "Bölgenin bilinen tarihi, arkeolojik izlerle MÖ 3000'lere kadar uzanır." },
    { year: "MÖ 2. binyıl", title: "Hitit · Frig · Lidya · Pers", text: "Anadolu'nun kadim uygarlıkları Hititler, Frigler ve Lidyalılar; ardından Persler bölgeye egemen oldu." },
    { year: "MÖ 4.–1. yy", title: "Helenistik Dönem & Pontus", text: "Büyük İskender sonrası Helenistik krallıklar ve Pontus, bölgenin kültürel dokusuna katkı sağladı." },
    { year: "MÖ 1. yy – MS 11. yy", title: "Roma & Bizans", text: "Roma ve ardından Bizans egemenliğinde yerleşim sürdü; dönemden mimari izler günümüze ulaştı." },
    { year: "1196", title: "Selçuklu Dönemi", text: "Bölge 12. yüzyıl sonunda Türklerin ve Selçukluların hâkimiyetine girdi." },
    { year: "1326 – 1461", title: "Beylikler Çağı", text: "Kösedağ sonrası önce Çobanoğulları, ardından Candaroğulları Beyliği bölgeyi yönetti." },
    { year: "1423", title: "Osmanlı Hâkimiyeti", text: "Kesin Osmanlı egemenliğiyle kent bugünkü kimliğini kazandı; konaklar, Cinci Han (1645) ve İncekaya Su Kemeri (18. yy sonu) bu dönemin eserleridir." },
    { year: "1923", title: "Cumhuriyet Dönemi", text: "Türkiye Cumhuriyeti ile birlikte kent, geleneksel dokusunu koruyarak günümüze taşındı." },
    { year: "17 Aralık 1994", title: "UNESCO Dünya Mirası", text: "Safranbolu, olağanüstü korunmuş Osmanlı kent dokusuyla Dünya Mirası Listesi'ne 614 numarayla girdi." },
  ],

  // Ottoman civil architecture / houses
  houses: {
    eyebrow: "Osmanlı Sivil Mimarisi",
    title: "Safranbolu Evleri",
    images: [
      { src: `${SB}/sb-pano-4.webp`, alt: "Yamaca kurulmuş beyaz cepheli, ahşap çıkmalı Safranbolu konakları" },
      { src: `${SB}/sb-street-1.webp`, alt: "Safranbolu'nun arnavut kaldırımlı dar sokağı ve tarihi konakları" },
    ],
    paragraphs: [
      "Safranbolu Evleri, yüzlerce yıllık bir süreçte oluşan; taş zemin, kerpiç dolgu ve ahşap iskeletiyle doğayla uyumlu bir mimari dilin ürünüdür. Geniş sofaları, ahşap tavanları ve çıkmalarıyla her konak başlı başına bir sanat eseridir.",
      "Evler; kışlık olarak kullanılan 'Şehir' ve yazlık olarak kullanılan 'Bağlar' olmak üzere iki kesimde gruplanır. Bu ikili yaşam biçimi, kentin mevsimsel ritmini yüzyıllardır korumaktadır.",
    ],
  },

  // Bazaar & crafts
  bazaar: {
    eyebrow: "Çarşı & Zanaat",
    title: "Arasta'nın canlı belleği",
    lead: `${SB}/sb-bazaar-1.webp`,
    leadAlt: "Safranbolu Tarihi Çarşısı'nda lokumcular, hediyelik tezgâhları ve gezginler",
    side: [
      { src: `${SB}/sb-craft-1.webp`, alt: "Safranbolu'da bir bakır ustasının tepsi üzerine desen işlemesi" },
      { src: `${SB}/sb-market-1.webp`, alt: "Geleneksel konak mutfağında dizili el yapımı bakır sahanlar" },
    ],
    paragraphs: [
      "Tarihi Çarşı'nın kalbindeki Arasta ve Cinci Han çevresinde; bakırcılar, demirciler, yemeniciler ve dokumacılar yüzyıllık zanaatlarını hâlâ sürdürür. Her sokak, ustaların çekiç sesleriyle geçmişe açılır.",
      "Burada alışveriş bir hediye değil, bir hafızayı yanınızda götürmektir: el işi bir bakır tepsi, dokuma bir kuşak ya da taze bir kutu lokum.",
    ],
  },

  // Saffron
  saffron: {
    eyebrow: "Şehre Adını Veren Altın",
    title: "Safran",
    images: [
      { src: `${SB}/sb-saffron-crocus.webp`, alt: "Kırmızı tepecikli mor safran çiçeği (Crocus sativus) yakın çekim" },
      { src: `${SB}/sb-saffron-threads-1.webp`, alt: "Cam kavanozdan dökülen kuru safran telleri" },
    ],
    paragraphs: [
      "Crocus sativus çiçeğinin telciklerinden elde edilen safran, dünyanın en pahalı baharatıdır ve yerleşime de adını vermiştir. En kalitelisinin Safranbolu topraklarında yetişmesi, kente asırlardır süren bir kimlik kazandırmıştır.",
      "Sofralara altın rengini ve eşsiz aromasını veren safran; zerdeden lokuma, kentin mutfağında da başrol oynar.",
    ],
  },

  // Lokum
  lokum: {
    eyebrow: "Benzersiz Lezzet",
    title: "Safranbolu Lokumu",
    images: [
      { src: `${SB}/sb-lokum-2.webp`, alt: "Vitrinde dizili çeşit çeşit cevizli ve meyveli Safranbolu lokumları" },
      { src: `${SB}/sb-lokum-1.webp`, alt: "İşlemeli bakır tabakta pudra şekerli lokum ve Türk kahvesi" },
    ],
    paragraphs: [
      "Türk mutfak kültürünün en sevilen lezzetlerinden lokum konusunda isim yapmış yerleşimlerden biridir Safranbolu. Diğerlerine göre daha hafif oluşu ve mineralce zengin doğal sularla hazırlanması, ününü pekiştirmiştir.",
      "Şehre geldiğinizde mutlaka tadılması ve hediyelik alınması gereken lezzetlerin başında gelir.",
    ],
  },

  // Magazine-style attraction features (only authentic imagery used)
  features: [
    { n: "01", name: "Tarihi Çarşı & Arasta", img: `${SB}/sb-bazaar-1.webp`, alt: "Safranbolu Tarihi Çarşısı sokağı ve dükkânları", text: "Osmanlı dokusunu yaşatan çarşıda zanaatkârlar, lokumcular ve kahvehaneler." },
    { n: "02", name: "Konaklar & Taş Sokaklar", img: `${SB}/sb-street-2.webp`, alt: "Safranbolu'nun ahşap çıkmalı konakları arasındaki taş döşeli sokak", text: "Ahşap çıkmalı konaklar arasında kıvrılan arnavut kaldırımlarda yürüyüş." },
    { n: "03", name: "Şehir Panoraması", img: `${SB}/sb-pano-2.webp`, alt: "Safranbolu'nun cami ve kiremit çatılarıyla panoramik manzarası", text: "Hıdırlık Tepesi'nden kızıl çatıların üzerine kurulan büyülü gün batımı." },
  ],

  // Nearby heritage & nature — real, verified Wikimedia Commons imagery
  nearby: [
    { name: "İncekaya Su Kemeri", img: `${SB}/sb-incekaya.webp`, alt: "Tokatlı Kanyonu üzerindeki tarihi İncekaya Su Kemeri'nin taş kemerleri gün batımında aydınlatılmış", desc: "18. yüzyıl sonunda Sadrazam İzzet Mehmet Paşa tarafından yaptırılan, Tokatlı Kanyonu üzerindeki görkemli Osmanlı su kemeri." },
    { name: "Bulak (Mencilis) Mağarası", img: `${SB}/sb-mencilis.webp`, alt: "Bulak (Mencilis) Mağarası'nın ışıklandırılmış sarkıt ve dikitleri", desc: "Sarkıt ve dikitleriyle etkileyici, yeraltı gölü bulunan doğa harikası mağara." },
    { name: "Yörük Köyü", img: `${SB}/sb-yoruk.webp`, alt: "Yörük Köyü'nün beyaz cepheli, ahşap çıkmalı geleneksel konakları ve güneşli taş sokağı", desc: "Geleneksel konak mimarisini bozulmadan koruyan, açık hava müzesi niteliğindeki tarihî köy." },
  ],

  // Attribution records (also stored in /images/safranbolu/CREDITS.md)
  credits:
    "Çevre lokasyon görselleri: İncekaya Su Kemeri — Muhammet Dilmaç; Mencilis Mağarası — Carotisque; Yörük Köyü — Tevfik Teker. Kaynak: Wikimedia Commons · Lisans: CC BY-SA 4.0.",


  transport: {
    title: "Safranbolu'ya Ulaşım",
    note: "İstanbul ve Ankara'dan kara yoluyla kolayca ulaşılır; her iki ilden düzenli otobüs seferleri bulunur.",
    routes: [
      { from: "İstanbul", time: "~5 saat" },
      { from: "Ankara", time: "~2.5 saat" },
    ],
  },

  // Kept for the homepage "Keşfet" preview
  attractions: [
    { name: "Safranbolu Tarihi Çarşı", desc: "Osmanlı dokusunu yaşatan geleneksel çarşı" },
    { name: "İncekaya Su Kemeri", desc: "Tarihi su kemeri ve eşsiz kanyon manzarası" },
    { name: "Bulak Mencilis Mağarası", desc: "Doğa harikası yeraltı mağarası" },
    { name: "Yörük Köyü", desc: "Korunmuş geleneksel köy mimarisi" },
  ],
};

// Full gallery pool from hotel photos
export const galleryImages = [
  `${IMG}/Safranbolu_Celebi_Otel-50-1024x684.jpg`,
  `${IMG}/Safranbolu_Celebi_Otel-51-1024x684.jpg`,
  `${IMG}/Safranbolu_Celebi_Otel-53-1024x684.jpg`,
  `${IMG}/Safranbolu_Celebi_Otel-54-1024x684.jpg`,
  `${IMG}/Safranbolu_Celebi_Otel-55-1024x684.jpg`,
  `${IMG}/Safranbolu_Celebi_Otel-68-1024x684.jpg`,
  `${IMG}/Safranbolu_Celebi_Otel-59-1024x684.jpg`,
  `${IMG}/Safranbolu_Celebi_Otel-34-1024x684.jpg`,
  `${IMG}/Safranbolu_Celebi_Otel-33-1024x684.jpg`,
  `${IMG}/Safranbolu_Celebi_Otel-31-1024x684.jpg`,
  `${IMG}/Safranbolu_Celebi_Otel-30-1024x684.jpg`,
  `${IMG}/Safranbolu_Celebi_Otel-27-1024x684.jpg`,
  `${IMG}/Safranbolu_Celebi_Otel-26-1024x684.jpg`,
  `${IMG}/Safranbolu_Celebi_Otel-25-1024x684.jpg`,
  `${IMG}/STANDART-AILE8-1024x683.jpg`,
  `${IMG}/STANDART-AILE7-jpg-1024x683.jpg`,
  `${IMG}/STANDART-AILE5-1024x683.jpg`,
  `${IMG}/STANDART-AILE3-1024x684.jpg`,
  `${IMG}/Safranbolu_Celebi_Otel-43-1024x684.jpg`,
  `${IMG}/Safranbolu_Celebi_Otel-45-1024x684.jpg`,
  `${IMG}/2023-aralik-celebiotel-047-scaled-1-1024x684.jpg`,
  `${IMG}/2023-aralik-celebiotel-048-scaled-1-1024x684.jpg`,
];

export const navItems = [
  { label: "Ana Sayfa", path: "/" },
  { label: "Odalar", path: "/odalar" },
  { label: "Restoran", path: "/restoran" },
  { label: "Safranbolu", path: "/safranbolu" },
  { label: "Galeri", path: "/galeri" },
  { label: "İletişim", path: "/iletisim" },
];
